import { css, jsx } from '@emotion/react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import 'react';
import { boxSizing } from '../../../style-mixins/reset.es.js';

const styles = {
  root: (height, width) => {
    const widthMap = {
      full: "100%",
      large: "75%",
      medium: "50%",
      small: "25%"
    };
    return css(Object.assign(Object.assign(Object.assign({}, boxSizing), Typography.SmallPrint4), { alignItems: "center", textTransform: "uppercase", color: Colors.TextWeakest, display: "flex", flex: 1, justifyContent: "space-between", letterSpacing: 1, padding: 0, position: "relative", textAlign: "center", width: widthMap[width] || "100%", "&::before, &::after": {
      borderBottom: `${height}px solid ${Colors.GrayWarm4}`,
      content: '""',
      flex: 1
    } }));
  },
  content: css({
    margin: "0 var(--zds-space-20)"
  })
};
const Divider = ({ height, width, children, "aria-hidden": ariaHidden = void 0 }) => {
  return jsx("div", { role: "separator", css: styles.root(height, width || "full"), "aria-hidden": ariaHidden }, children && jsx("span", { css: styles.content }, children));
};

export { Divider };
//# sourceMappingURL=Divider.es.js.map
